export enum AnnotationShapeType {
  RECTANGLE = "rectangle",
  CIRCLE = "circle",
  TEXT = "text",
  LINK = "link"
}
